import axios from "axios";

const state = {
  games: null,
  weeklyScores: null,
  selected_week_id: null,
  selected_play_week_num: null,
  latest_completed_week: null,
  form_6: null,
};

const getters = {
  games(state) { return state.games},
  weeklyScores(state) { return state.weeklyScores},
  selected_week_id(state) { return state.selected_week_id},
  selected_play_week_num(state) { return state.selected_play_week_num},
  latest_completed_week(state) { return state.latest_completed_week},
  form_6(state) { return state.form_6},
};

const actions = {
  getLatestCompletedWeek({ commit, dispatch }) {
    axios.get(process.env.VUE_APP_API_URL + 'week/get_latest_completed_week')
    .then(response => {
      commit('SET_LATEST_COMPLETED_WEEK', response.data.data.week);
      commit('SET_SELECTED_WEEK_ID', response.data.data.week.id);
      commit('SET_SELECTED_PLAY_WEEK_NUM', response.data.data.week.play_week_num);
      dispatch('getWeeklyScores', { weekId: response.data.data.week.id })
    })
  },
  setSelectedWeekInfo({ commit }, week) {
    commit('SET_SELECTED_WEEK_ID', week.id);
    commit('SET_SELECTED_PLAY_WEEK_NUM', week.play_week_num);
  },
  setSelectedPlayWeekNum({ commit }, data) {
    commit('SET_SELECTED_PLAY_WEEK_NUM', data.weeknum);
  },
  getWeeklyScores({ commit }, weekId) {
    axios.get(process.env.VUE_APP_API_URL + `weekly_scores/${weekId.weekId}`)
    .then(response => {
      commit('SET_GAMES', response.data.games);
      commit('SET_WEEKLY_SCORES', response.data.pred_array);
    })
  },
  getForm6({ commit }) {
    axios.get(process.env.VUE_APP_API_URL + `weekly_scores/6_week_form`)
    .then(response => {
      commit('SET_FORM_6', response.data.data)
    })
  }
};

const mutations = {
  SET_LATEST_COMPLETED_WEEK(state, data) { state.latest_completed_week = data },
  SET_SELECTED_WEEK_ID(state, data) { state.selected_week_id = data },
  SET_SELECTED_PLAY_WEEK_NUM(state, data) { state.selected_play_week_num = data },
  SET_GAMES(state, data) { state.games = data },
  SET_WEEKLY_SCORES(state, data) { state.weeklyScores = data },
  SET_FORM_6(state, data) { state.form_6 = data },
};


export default {
  state,
  getters,
  actions,
  mutations,
}
